import { P2GButton, P2GLink } from '@parcel2go/core-ui';

interface LinkProps {
  component?: 'button' | 'link';
  linkVariant?: 'body2' | 'body1';
  buttonVariant?: 'primary' | 'secondary' | 'tertiary';
  onClick: () => void;
  fullWidth?: boolean;
  children: React.ReactNode;
}
export const ClickableComponent = ({
  component,
  linkVariant,
  buttonVariant,
  onClick,
  fullWidth,
  children
}: LinkProps) =>
  component === 'button' ? (
    <P2GButton variant={buttonVariant} onClick={onClick} fullWidth={fullWidth}>
      {children}
    </P2GButton>
  ) : (
    <P2GLink variant={linkVariant} onClick={onClick}>
      {children}
    </P2GLink>
  );
